module.exports = __webpack_public_path__ + "img/alentour18.845ff0e4.jpg";